import { Pipe, PipeTransform } from "@angular/core";
import { EletronicTransferStatus } from "../enum/eletronic-transfer-status.enum";

@Pipe({
  name: "scpTicketTransferStatus",
})
export class TicketTransferStatusPipe implements PipeTransform {
  transform(status: EletronicTransferStatus): any {
    let translateTo = "";

    switch (status) {
      case EletronicTransferStatus.PENDING:
        translateTo = "Pendente";
        break;
      case EletronicTransferStatus.SENT:
        translateTo = "Em trânsito";
        break;
      case EletronicTransferStatus.PAID:
        translateTo = "Concluído";
        break;
      case EletronicTransferStatus.RETURNED:
        translateTo = "Devolvida";
        break;
      case EletronicTransferStatus.ERROR:
        translateTo = "Erro";
        break;
      case EletronicTransferStatus.INTEGRATION_ERROR:
        translateTo = "Erro integração";
        break;
      case EletronicTransferStatus.CHARGEBACK:
        translateTo = "Estornada";
        break;
      case EletronicTransferStatus.SCHEDULED:
        translateTo = "Agendada";
        break;
      case EletronicTransferStatus.DENIED:
        translateTo = "Negada";
        break;
      default:
        translateTo = "";
        break;
    }

    return translateTo;
  }
}
